const allStatuses = ['Launched', 'In progress', 'Not started'];

export default allStatuses;
